export const enum TabView {
    Chat,
    Channels,
    ContactBank,
}
